import script from "./ConfirmationPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationPopup.vue?vue&type=style&index=0&id=37dededb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37dededb"]])

export default __exports__